import React from "react";
import { Button, CircularProgress } from "@mui/material";

const PrimaryButton = ({
  children,
  isLoading,
  disabled,
  startIcon,
  sx,
  ...props
}) => {
  return (
    <Button
      variant="contained"
      color="primary"
      disabled={isLoading || disabled}
      disableElevation
      startIcon={isLoading ? undefined : startIcon}
      sx={{
        fontWeight: 600,
        borderRadius: "8px",
        textTransform: "none",
        height: "45px",
        backgroundColor: "#1d4ed8",
        color: "white",
        "&:hover": {
          backgroundColor: "#1e40af",
        },
        ...sx,
      }}
      {...props}
    >

      {isLoading ? <CircularProgress size={20} color="inherit" /> : children}
    </Button>
  );
};

export default PrimaryButton;
